// carrierMapper.js
export function getCarrierDisplayName(carrierName, trackingNumber = "") {
    if (!carrierName) return "";

    const cleanCarrier = String(carrierName).trim().toUpperCase();

    // ─── EARLY EXIT: IF CARRIER IS OTHERS, DO NOT RUN PREFIX RULES ───
    if (cleanCarrier === "OTHERS") {
        return "OTHERS";
    }

    const tracking = String(trackingNumber).trim();

    // Prefix-based mapping rules
    if (tracking.startsWith("1Z")) {
        return "UPS";
    }
    if (tracking.startsWith("52")) {
        return "PUROLATOR";
    }
    if (tracking.toUpperCase().startsWith("U")) {
        return "UNIEXPRESS";
    }

    // Default fallback if no prefix matches
    return carrierName;
}